import {reactive} from 'vue'

export function fromEntries<K extends string | number, V> (arr: [K, V][]): Record<K, V> {
	return Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })))
}

export function intKeys (object: Record<string | number, any>) {
	return Object.keys(object).map(k => parseInt(k))
}

export function intKeyedEntries<T> (object: Record<number, T>) {
	return Object.entries(object).map(e => {
		return [parseInt(e[0]), e[1]] as [number, T]
	})
}

export function subtract<T> (minuend: T[], subtrahend: T[]) {
	return minuend.filter((i) => !subtrahend.includes(i))
}

export function firstFreeIndex(indices: any[], startFrom = 0) {
	for (let i = 0; i < indices.length; i++) {
		if (indices[i] > i + startFrom) {
			return i + startFrom
		}
	}
	return indices.length + startFrom
}

export function* range (start: number, end: number) {
	for (let i = start; i <= end; i ++) {
		yield i
	}
}

export function arrayEquals<T> (left: T[], right: T[]) {
	return subtract(left, right).length === 0 && subtract(right, left).length === 0
}

export function makeArray<T> (item: T, length: number): T[] {
	const arr = []
	for (let i = 0; i < length; i++) {
		arr.push(item)
	}
	return arr
}

export function copy<T extends Record<any, any>> (object: T) {
	return reactive({ ... object })
}

export function pad (num: number, length: number) {
	return (makeArray('0', length - 1).join('') + num).slice(-length)
}

export function formatNumber (number: number) {
	const pieces = ('' + number).split('.')
	let ret = pieces[0].split('').reverse().join('').match(/(.{1,3})/g)!!.join(' ').split('').reverse().join('')
	if (pieces[1]) {
		ret += '.' + pieces[1]
	}
	return ret
}

export function formatAmount (sum: number) {
	const pieces = ('' + sum).split('.')
	let ret = pieces[0].split('').reverse().join('').match(/(.{1,3})/g)!!.join(',').split('').reverse().join('')
	if (pieces[1]) {
		ret += '.' + pieces[1]
	}
	return ret
}

export function formatDate (date: Date) {
	const day = date.getDate()
	const month = date.getMonth()
	const year = date.getFullYear()
	const hours = date.getHours()
	const minutes = date.getMinutes()
	const seconds = date.getSeconds()
	return pad(day, 2) + '.' + pad(month + 1, 2) + '.' + year + ' ' + pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2)
}

export function formatValue (type: string, value: any) {
	switch (type) {
	case 'Integer':
	case 'Long':
		return formatNumber(value)
	case 'Amount':
		return formatAmount(value)
	case 'Timestamp':
		return formatDate(new Date(value))
	default:
		return value
	}
}

export function isInt (value: any) {
	return '' + parseInt(value) === '' + value
}
